import { useAppSelector } from '../../store/storeHooks';
import { StateActionById } from '../../types';

const useOurSelectById = (action: StateActionById, id: string) =>
  useAppSelector((state) => action(state, id));

export default useOurSelectById;
